import { cn } from '@/lib/utils'
import markUrl from '@/assets/configurewise-mark-blue.svg'

interface BrandLogoProps {
  className?: string
  markClassName?: string
  wordmarkClassName?: string
  showDescriptor?: boolean
}

export function BrandLogo({ className, markClassName, wordmarkClassName, showDescriptor = true }: BrandLogoProps) {
  return (
    <span className={cn('flex items-center gap-2.5', className)}>
      <img src={markUrl} alt="" className={cn('h-7 w-auto shrink-0 select-none', markClassName)} />
      <span className="flex min-w-0 flex-col justify-center">
        <span
          className={cn(
            'font-brand text-[15px] font-semibold leading-none tracking-[-0.01em] text-ink',
            wordmarkClassName,
          )}
        >
          ConfigureWise
        </span>
        {showDescriptor ? (
          <span className="mt-[5px] font-brand text-[9.5px] font-medium uppercase leading-none tracking-[0.22em] text-ink-faint">
            Finance
          </span>
        ) : null}
      </span>
    </span>
  )
}
